<template>
  <div>
    <v-app-bar class="hidden-sm-and-down">
      <v-toolbar-title>
        <router-link :to="{ name: 'TopIndex' }">
          <img src="/static/icon/logo.png" :alt="$t('site_name')" height="50" />
        </router-link>
      </v-toolbar-title>
      <v-spacer />

      <!-- 学習系をまとめたドロップダウン -->
      <v-menu open-on-hover offset-y>
        <template #activator="{ on, attrs }">
          <a
            href="javascript:void(0)"
            v-bind="attrs"
            class="mr-3"
            style="cursor: pointer"
            :class="{ 'active-menu': $route.path.match(/^\/topic(\/|\?|$)/) }"
            v-on="on"
            @click.prevent
          >
            <v-icon left> fa-book </v-icon>{{ $t('menu.topic') }}
            <v-icon small right>arrow_drop_down</v-icon>
          </a>
        </template>
        <v-list dense>
          <v-list-item :to="{ name: 'TopicBasic' }">
            <v-icon left small style="margin-right: 14px !important">fa-book</v-icon>
            <v-list-item-title>{{ $t('menu.topic_basic') }}</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'TopicAdvanced' }">
            <v-icon left small>fa-graduation-cap</v-icon>
            <v-list-item-title>{{ $t('menu.topic_advanced') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-icon left> show_chart </v-icon>
      <router-link
        :to="{ name: 'MarketIndex' }"
        class="mr-3"
        :class="{ 'active-menu': $route.path.match(/^\/market(\/|\?|$)/) }"
      >
        {{ $t('menu.market') }}
      </router-link>

      <!-- 出来高急増・年初来高値・セクターランキングをまとめたドロップダウン -->
      <v-menu open-on-hover offset-y>
        <template #activator="{ on, attrs }">
          <a
            href="javascript:void(0)"
            v-bind="attrs"
            class="mr-3"
            style="cursor: pointer"
            :class="{ 'active-menu': $route.path.match(/^\/(volumespike|yearhigh|s33)(\/|\?|$)/) }"
            v-on="on"
            @click.prevent
          >
            <v-icon left> query_stats </v-icon>{{ $t('menu.highlight_group') }}
            <v-icon small right>arrow_drop_down</v-icon>
          </a>
        </template>
        <v-list dense>
          <v-list-item :to="{ name: 'VolumespikeIndex' }">
            <v-icon left small>fa-rocket</v-icon>
            <v-list-item-title>{{ $t('menu.volumespike') }}</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'YearhighIndex' }">
            <v-icon left small>fa-crown</v-icon>
            <v-list-item-title>{{ $t('menu.yearhigh_index') }}</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'SectorIndex' }">
            <v-icon left small>view_module</v-icon>
            <v-list-item-title>{{ $t('menu.sector_index') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-icon left> fa-bell </v-icon>
      <router-link
        :to="{ name: 'FinanceIndex' }"
        class="mr-3"
        :class="{ 'active-menu': $route.path.match(/^\/finance(\/|\?|$)/) }"
      >
        {{ $t('menu.finance') }}
      </router-link>

      <v-icon left> search </v-icon>
      <router-link
        :to="{ name: 'CompanyIndex' }"
        class="mr-3"
        :class="{ 'active-menu': $route.path.match(/^\/company(\/|\?|$)/) }"
      >
        {{ $t('menu.company') }}
      </router-link>

      <v-icon left> newspaper </v-icon>
      <router-link
        :to="{ name: 'ArticleIndex' }"
        class="mr-3"
        :class="{ 'active-menu': $route.path.match(/^\/article(\/|\?|$)/) }"
      >
        {{ $t('menu.article') }}
      </router-link>
    </v-app-bar>
    <v-app-bar class="hidden-md-and-up">
      <v-toolbar-title>
        <router-link :to="{ name: 'TopIndex' }">
          <img src="/static/icon/logo.png" :alt="$t('site_name')" height="50" />
        </router-link>
      </v-toolbar-title>
      <v-spacer />
      <v-menu>
        <template #activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-list style="min-width: 7em">
          <v-list-item :to="{ name: 'TopicBasic' }">
            <v-list-item-title>{{ $t('menu.topic_basic') }}</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'TopicAdvanced' }">
            <v-list-item-title>{{ $t('menu.topic_advanced') }}</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'MarketIndex' }">
            <v-list-item-title>{{ $t('menu.market') }}</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'FinanceIndex' }">
            <v-list-item-title>{{ $t('menu.finance') }}</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'VolumespikeIndex' }">
            <v-list-item-title>{{ $t('menu.volumespike') }}</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'YearhighIndex' }">
            <v-list-item-title>{{ $t('menu.yearhigh_index') }}</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'SectorIndex' }">
            <v-list-item-title>{{ $t('menu.sector_index') }}</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'CompanyIndex' }">
            <v-list-item-title>{{ $t('menu.company') }}</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'ArticleIndex' }">
            <v-list-item-title>{{ $t('menu.article') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-layout v-if="$route.path !== '/'" row wrap class="pa-3 mt-1">
      <v-breadcrumbs :items="breadcrumbs" class="pa-3" />
      <!--
      <v-spacer />
      <LocaleSwitch />
      -->
    </v-layout>
  </div>
</template>
<script>
//import LocaleSwitch from '@/components/locale/LocaleSwitch'

export default {
  name: 'AppToolbar',
  components: {
    //LocaleSwitch,
  },

  computed: {
    breadcrumbs() {
      const { matched } = this.$route
      let prev = null
      return matched
        .map((route, index) => {
          const to =
            index === matched.length - 1 ? this.$route.path : 'path' in route ? route.path || '/' : route.redirect
          const text = this.$t('menu.' + route.meta.title)
          const ignored = to === prev || to === prev + '/'
          prev = to
          if (ignored) {
            return null
          }
          return {
            text: text,
            to: to,
            exact: true,
            disabled: false,
          }
        })
        .filter((route) => route !== null)
    },
  },
}
</script>
